import React from "react";
import { Grid, TextField } from "@mui/material";

const ReportingStep = ({ formData, handleChange }) => {
  return (
    <Grid container spacing={2.5}>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Reporting Name" name="reportingName" value={formData.reportingName} onChange={handleChange} fullWidth size="small" required />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Report Contact" name="reportContact" value={formData.reportContact} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Report Address" name="reportAddress" value={formData.reportAddress} onChange={handleChange} fullWidth size="small" required />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Report Address 2" name="reportAddress2" value={formData.reportAddress2} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Report City" name="reportCity" value={formData.reportCity} onChange={handleChange} fullWidth size="small" required />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Report State" name="reportState" value={formData.reportState} onChange={handleChange} fullWidth size="small" required />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Report Zip" name="reportZip" value={formData.reportZip} onChange={handleChange} fullWidth size="small" required />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Report Country" name="reportCountry" value={formData.reportCountry} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Report Phone 1" name="reportPhone1" value={formData.reportPhone1} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Report Phone 2" name="reportPhone2" value={formData.reportPhone2} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Report Fax" name="reportFax" value={formData.reportFax} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Report Email" name="reportEmail" value={formData.reportEmail} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Report Format" name="reportFormat" value={formData.reportFormat} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Reporting Comments" name="reportingComments" value={formData.reportingComments} onChange={handleChange} fullWidth size="small" multiline rows={1} />
      </Grid>
    </Grid>
  );
};

export default ReportingStep;
